import { useContext } from 'react';

import { Col, Row } from 'react-bootstrap';

import { FormContext, StringInput } from '../core/components/forms';

interface ClientVezemKolesaProps {
  clientId: string,
}

// Поля согласия, выведенные отдельной таблицей (сверху от исходного JSON)
const CONSENT_FIELDS = [
  { key: 'pageUrl', title: 'Адрес страницы' },
  { key: 'fullName', title: 'ФИО' },
  { key: 'ipAddress', title: 'IP-адрес' },
  { key: 'sessionId', title: 'ID сессии' },
  { key: 'userAgent', title: 'User-Agent' },
  { key: 'consentDate', title: 'Дата согласия' },
  { key: 'consentText', title: 'Текст согласия' },
  { key: 'consentType', title: 'Тип согласия' },
  { key: 'documentUrl', title: 'Ссылка на документ' },
  { key: 'phoneNumber', title: 'Телефон' },
  { key: 'idempotencyKey', title: 'Уникальный ключ запроса' },
  { key: 'consentTimezone', title: 'Часовой пояс' },
];

const ClientVezemKolesa = (props: ClientVezemKolesaProps) => {
  const {
    clientId,
  } = props;

  // @ts-ignore — FormContext создаётся в нетипизированном JS (core/forms/utils.js), типизация запланирована в CONTEXT.md §5.2
  const { values } = useContext(FormContext);

  // Согласия из ответа клиента — пока только показываем, без редактирования.
  // Приходит массив; одиночный объект на всякий случай оборачиваем в массив.
  const consents = values?.vezemkolesaPrivacyConsents;
  const consentsList = Array.isArray(consents)
    ? consents
    : (consents ? [consents] : []);
  const hasConsents = consentsList.length > 0;

  return (
    <Col md={ 12 }>
      <Row>
        <Col md={ 4 }>
          <StringInput
            name='emailFromVezemkolesa'
            label='Email'
            placeholder='Email'
            disabled
          />
        </Col>
      </Row>
      <Row>
        <Col md={ 12 }>
          <div className='font-weight-bold mb-1'>Согласия на обработку персональных данных</div>
          { hasConsents
            ? (
              <>
                { consentsList.map((consent, index) => (
                  <div key={ index } className='mb-3'>
                    { consentsList.length > 1
                      && <div className='font-weight-bold mb-1'>{ `Согласие ${ index + 1 }` }</div> }
                    <table className='table table-sm table-striped mb-0'>
                      <tbody>
                        { CONSENT_FIELDS.map(({ key, title }) => (
                          <tr key={ key }>
                            <th scope='row' className='w-25'>{ title }</th>
                            <td className='text-break'>{ consent?.[key] ?? '—' }</td>
                          </tr>
                        )) }
                      </tbody>
                    </table>
                  </div>
                )) }
                <div className='text-muted small mb-1'>Исходный JSON</div>
                <pre className='bg-light border rounded p-3 text-monospace small mb-0 overflow-auto'>
                  { JSON.stringify(consents, null, 2) }
                </pre>
              </>
            )
            : <div className='text-muted'>Нет данных</div> }
        </Col>
      </Row>
    </Col>
  );
};

export default ClientVezemKolesa;
